// extracted by mini-css-extract-plugin
export default {"title":"LeftSide_title__dfzxt","space":"LeftSide_space__dC+Av","list":"LeftSide_list__XHAM4","footer":"LeftSide_footer__t1NXP"};